import classNames from 'classnames';
import type {
  ErrorNode,
  SecuritySchemaNodeComponentProps,
} from 'components/SecuritySchema/model/SecuritySchemaNode';
import { renderReferenceMetaInfo } from 'components/SecuritySchema/nodeComponents/renderReferenceMetaInfo';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

/**
 * Currently we inline referenced tests directly into the tree, so this component
 * is used only to display possible errors on invalid references.
 */
export const CErrorNode: FC<SecuritySchemaNodeComponentProps<ErrorNode>> = ({
  node,
  context,
}) => {
  const msg = useLocale();
  const msgError = msg.securitySchema.test.error;

  return (
    <div
      className={classNames(
        'security-tree-node security-tree-node--test-error',
        context.highlightedSubtree && 'security-tree-node--highlighted',
      )}
    >
      {node.referenceInfo && renderReferenceMetaInfo(node.referenceInfo, msg)}
      <p className='security-tree-node__heading'>{msgError.label}</p>
      <p>{msgError[node.errorType]}</p>
    </div>
  );
};
